import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { type Center } from '@avanta/shared/types/appointments';
import { type AppQueryOptions } from '@avanta/shared/types/queries';

export const fetchCenterDetailsQueryOptions = (
  centerId: number
): AppQueryOptions<Center, readonly [typeof QUERY_KEYS.FETCH_CENTER_DETAILS, number]> =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_CENTER_DETAILS, centerId] as const,
    queryFn: async () => (await AppointmentService.getCenterDetails(centerId)).data,
    staleTime: FIFTEEN_MINUTES,
    gcTime: FIFTEEN_MINUTES,
  });

export const useFetchCenterDetails = (centerId: number): UseQueryResult<Center, Error> =>
  useQuery({
    ...fetchCenterDetailsQueryOptions(centerId),
    enabled: Boolean(centerId),
  });
